var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-321 -296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#226BEF",
    transform: "translate(321 296)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.659 58.072a1.281 1.281 0 0 0-1.8.208l-5.9 7.435-3.529-3.764a1.281 1.281 0 1 0-1.87 1.752l4.544 4.848a1.28 1.28 0 0 0 .935.406h.061a1.283 1.283 0 0 0 .951-.485l6.821-8.6a1.281 1.281 0 0 0-.213-1.8z",
    transform: "translate(274.819 246.625)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckActive);
export default __webpack_public_path__ + "static/media/icon-check_active.3a3b526f8d6ad761e0a024b69706d2c7.svg";
export { ForwardRef as ReactComponent };